export const enum ReactionUniqType {
  uniq = 'uniq',
  upper = 'upper'
}
